export default "__VITE_ASSET__DZk01DCc__"